
export { getDonationFormCanonicalTags } from "/tmp/build_045f4e17/packages/common/lib-esm/helpers/meta.js"